import React, { useRef, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import ConfettiGenerator from "confetti-js";
import { ConfettiContainer } from '../styles';

export const ConfettiCanvas = ({ isShowingConfetti, onStop }) => {
  const confettiRef = useRef(null);

  const confettiSettings = useMemo(() => ({
    target: "my-canvas",
    max: "100",
    size: "1",
    animate: true,
    props: ["circle", "square", "triangle", "line"],
    colors: [
      [165, 104, 246],
      [230, 61, 135],
      [0, 199, 228],
      [253, 214, 126],
    ],
    clock: "25",
    rotate: false,
    width: window.screen.width,
    height: window.screen.height,
    start_from_edge: true,
    respawn: false,
  }), []);

  useEffect(() => {
    if (isShowingConfetti) {
      const confetti = new ConfettiGenerator(confettiSettings);
      confettiRef.current = confetti;
      confettiRef.current.render();
      
      // Auto-stop confetti after 3 seconds
      const timer = setTimeout(() => {
        handleStop();
      }, 3000);
      
      return () => {
        clearTimeout(timer);
        if (confettiRef.current) {
          confettiRef.current.clear();
        }
      };
    }

    return () => {
      if (confettiRef.current) {
        confettiRef.current.clear();
      }
    };
  }, [isShowingConfetti, confettiSettings]);

  const handleStop = () => {
    if (confettiRef.current) {
      confettiRef.current.clear();
    }
    onStop();
  };

  if (!isShowingConfetti) return null;

  return (
    <ConfettiContainer>
      <canvas id="my-canvas" />
      <div 
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          background: 'rgba(255, 255, 255, 0.9)',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#666',
          pointerEvents: 'auto',
          zIndex: 1001,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}
        onClick={handleStop}
        title="Dismiss celebration"
      >
        ×
      </div>
    </ConfettiContainer>
  );
};

ConfettiCanvas.propTypes = {
  isShowingConfetti: PropTypes.bool.isRequired,
  onStop: PropTypes.func.isRequired,
}; 